export default {
  channel_type: null,
  channel_identifier: null,
  search: null,
};
